module.exports = __webpack_public_path__ + "static/img/pos_multiple_device.1835537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_multiple_device.png
// module id = epOs
// module chunks = 8